export const routes={
  PAGE_NOT_FOUND: "*",
  SIGNIN: "/",
  SIGNUP: "/sign-up",
  COMPLETEUSERDATA: "/complete-user-data",
  USER: "/home/:username",
  PRODUCT: '/product-page/:id',
  CV_PREVIEW: '/cv/download',
  PAYMENT: '/payment',
  MEMBERSHIP: '/membership',
  ADMIN_CONSOLE: '/admin-console',
  MARKET_PLACE: '/marketplace',
  PEOPLE: '/people',
  APLICANTDB: '/applicant-database',
  SCHOOLS: '/schools',
  NEWS: '/news',
  CONFESSIONS: '/confessions',
  EXPERIENCES: '/experiences',
  DISCORD: '/discord',
  REDIRECT_BY_EMAIL: '/redirect-by-email/:id'
}